//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'GAS_Centor',
  data () {
    return {
      form: {
        antiadoncus: '0',
        fever: '0',
        nodes: '0',
        nocough: '0'
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = form.antiadoncus + form.fever + form.nodes + form.nocough
        if (result < 3) {
          self.descTxt = '链球菌咽炎可能性小，不需要检测链球菌 '
        } else if (result > 3 || result === 3) {
          self.descTxt = '链球菌咽炎可能性大，建议检测链球菌'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/GAS_Centor.vue